import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import About from "./pages/About";
import Gallery from "./pages/Gallery";
import Rooms from "./pages/Rooms";
import Packages from "./pages/Packages";
import Explore from "./pages/Explore";
import Login from "./pages/Login";
import Register from "./pages/Register";
import MyBookings from "./pages/MyBookings";
import BookingDetailPage from "./pages/BookingDetailPage";
import Tickets from "./pages/Tickets";
import TicketPrintPage from "./pages/TicketPrintPage";
import { Toaster } from "./components/ui/sonner";
import { HotelProvider } from "./context/HotelContext";
import { AuthProvider } from "./context/AuthContext";
import HotelGuard from "./components/HotelGuard";

function App() {
  return (
    <BrowserRouter>
      <HotelProvider>
        <HotelGuard>
          <AuthProvider>
            <div className="App">
              <ScrollToTop />
              <Header />
              <main className="min-h-screen">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/gallery" element={<Gallery />} />
                  <Route path="/rooms" element={<Rooms />} />
                  <Route path="/packages" element={<Packages />} />
                  <Route path="/explore" element={<Explore />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/my-bookings" element={<MyBookings />} />
                  <Route path="/my-bookings/:bookingId" element={<BookingDetailPage />} />
                  <Route path="/tickets" element={<Tickets />} />
                  <Route path="/tickets/order/:orderRef" element={<TicketPrintPage />} />
                </Routes>
              </main>
              <Footer />
              <Toaster />
            </div>
          </AuthProvider>
        </HotelGuard>
      </HotelProvider>
    </BrowserRouter>
  );
}

export default App;
